export default __webpack_public_path__ + "static/media/icon-export.ef18c614.svg";